import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosEnrollmentAppApi } from "../../../../axios.js";
import {
  GET_ENROLLMENT_QUEUE_BY_DATE,
  GET_DEPOSIT_TRANSACTION_BY_DEPOSITS,
} from "../../../../Urls.js";

const initialState = {
  enrollmentQueuebyDate: { data: [], loading: false, successMessage: "" },
  transactionByDeposit: { data: [], loading: false, successMessage: "" },
};

export const getEnrollmentQueuebyDate = createAsyncThunk(
  "app/enrollmentQueueSlice/getEnrollmentQueuebyDate",
  async (payload) => {
    const {
      startDate,
      endDate,
      limit,
      firstName,
      lastName,
      email,
      phone,
      community,
      street,
      city,
      state,
      zip,
      statusCodes
    } = payload;

    // Build query params dynamically
    const params = {
      startDate,
      endDate,
      limit,
      ...(firstName ? { firstName } : {}),
      ...(lastName ? { lastName } : {}),
      ...(email ? { email } : {}),
      ...(phone ? { phone } : {}),
      ...(community ? { community } : {}),
      ...(street ? { street } : {}),
      ...(city ? { city } : {}),
      ...(state ? { state } : {}),
      ...(zip ? { zip } : {}),
      ...(statusCodes && statusCodes.length ? { statusCodes } : {}),
    };

    const searchParams = new URLSearchParams();

Object.entries(params).forEach(([key, value]) => {
  if (Array.isArray(value)) {
    value.forEach(v => searchParams.append(key, v));
  } else if (value !== undefined && value !== null) {
    searchParams.append(key, value);
  }
});

    const response = await axiosEnrollmentAppApi.get(
      `${GET_ENROLLMENT_QUEUE_BY_DATE}`,
      {
    params: searchParams,
  }
    );

    return response;
  }
);

export const saveEnrollmentQueue = createAsyncThunk(
  "app/enrollmentQueueSlice/saveEnrollmentQueue",
  async (payload) => {
    const response = await axiosEnrollmentAppApi.post(
      "api/v1/Session/save-session-data",
      { enrolment: payload }
    );
    return response.data;
  }
);
export const submitEnrollmentQueue = createAsyncThunk(
  "app/enrollmentQueueSlice/submitEnrollmentQueue",
  async (payload) => {
    const response = await axiosEnrollmentAppApi.post(
      "api/v1/Session/save-and-submit-session-data",
      { enrolment: payload }
    );
    return response.data;
  }
);

export const getDepositTransactionByDeposit = createAsyncThunk(
  "app/enrollmentQueueSlice/getDepositTransactionByDeposit",
  async ({ depositId, txnTypeCode }) => {
    const url = `${GET_DEPOSIT_TRANSACTION_BY_DEPOSITS}${depositId}`;
    const response = await axiosEnrollmentAppApi.get(url, {
      params: { txnTypeCode },
    });
    return response.data;
  }
);

export const enrollmentQueueSlice = createSlice({
  name: "enrollmentQueueSlice",
  initialState,
  reducers: {
    clearData: (state) => {
      state.transactionByDeposit.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEnrollmentQueuebyDate.pending, (state) => {
        state.enrollmentQueuebyDate.loading = true;
      })
      .addCase(getEnrollmentQueuebyDate.fulfilled, (state, action) => {
        state.enrollmentQueuebyDate.loading = false;
        state.enrollmentQueuebyDate.data = action?.payload?.data?.data;
      })
      .addCase(getEnrollmentQueuebyDate.rejected, (state) => {
        state.enrollmentQueuebyDate.loading = false;
      })
      .addCase(getDepositTransactionByDeposit.pending, (state) => {
        state.transactionByDeposit.loading = true;
      })
      .addCase(getDepositTransactionByDeposit.fulfilled, (state, action) => {
        state.transactionByDeposit.loading = false;
        state.transactionByDeposit.data = action?.payload?.data;
      })
      .addCase(getDepositTransactionByDeposit.rejected, (state) => {
        state.transactionByDeposit.loading = false;
        state.transactionByDeposit.data = [];
      });
  },
});
export const { clearData } = enrollmentQueueSlice.actions;

export default enrollmentQueueSlice.reducer;
